import { L2ChainId, TokenId, Wei } from 'types'
import { ApiV1Response, http } from './http'

export interface TokenReserve {
  [x: L2ChainId]: Wei
}
export async function getTokenReserve<T extends ApiV1Response<TokenReserve>>(
  tokenId: TokenId
): Promise<T> {
  const r = await http.get<T>(`/market/l2/token/reserve/${tokenId}`)
  return r.data
}
